module.exports = __webpack_public_path__ + "static/wood-dc28b466ca0b5a2c3cdb33f97e2e4254.mp4";